// extracted by mini-css-extract-plugin
module.exports = {"DoubleImages":"yuiUo"};